export default __webpack_public_path__ + "assets/images/2d5683b02d92e47a80695562df201b20.png";